import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { ArrowDownToLine, Package, CheckCircle, Clock, Truck, FileText, AlertCircle } from 'lucide-react';
export function WarehouseInbound() {
  const inboundOrders = [{
    id: 'INB-001',
    poNumber: 'PO-2023-001',
    supplier: 'Indofood',
    products: [{
      name: 'Indomie Goreng Special',
      quantity: 500,
      unit: 'Karton'
    }, {
      name: 'Indomie Soto',
      quantity: 300,
      unit: 'Karton'
    }],
    totalItems: 800,
    status: 'in_transit',
    statusLabel: 'Dalam Perjalanan',
    expectedDate: 'Hari ini, 14:00',
    courier: 'Indofood Logistics',
    trackingNumber: 'IFL-2023-001',
    notes: 'Fragile - Handle with care'
  }, {
    id: 'INB-002',
    poNumber: 'PO-2023-005',
    supplier: 'Danone',
    products: [{
      name: 'Aqua Galon 19L',
      quantity: 200,
      unit: 'Galon'
    }],
    totalItems: 200,
    status: 'scheduled',
    statusLabel: 'Terjadwal',
    expectedDate: 'Besok, 10:00',
    courier: 'Danone Distribution',
    trackingNumber: 'DAN-2023-002',
    notes: 'Check expiry dates'
  }, {
    id: 'INB-003',
    poNumber: 'PO-2023-003',
    supplier: 'Indofood',
    products: [{
      name: 'Indomie Ayam Bawang',
      quantity: 400,
      unit: 'Karton'
    }],
    totalItems: 400,
    status: 'arrived',
    statusLabel: 'Tiba - Menunggu Proses',
    expectedDate: 'Tiba 30 menit lalu',
    courier: 'Indofood Logistics',
    trackingNumber: 'IFL-2023-003',
    notes: 'Priority - Process immediately'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'in_transit':
        return 'warning';
      case 'scheduled':
        return 'neutral';
      case 'arrived':
        return 'success';
      default:
        return 'neutral';
    }
  };
  return <div className="space-y-6" data-id="element-3664">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-3665">
        <div data-id="element-3666">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-3667">
            Inbound Management
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-3668">
            Kelola barang masuk dari pabrik
          </p>
        </div>
        <Button variant="primary" size="sm" icon={<ArrowDownToLine className="w-4 h-4" data-id="element-3670" />} data-id="element-3669">
          Schedule Inbound
        </Button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-3671">
        <Card className="p-4 bg-blue-50 border-blue-200" data-id="element-3672">
          <div className="flex items-center justify-between" data-id="element-3673">
            <div data-id="element-3674">
              <p className="text-xs text-blue-700 mb-1" data-id="element-3675">Total Inbound</p>
              <p className="text-2xl font-bold text-blue-900" data-id="element-3676">3</p>
            </div>
            <ArrowDownToLine className="w-8 h-8 text-blue-600" data-id="element-3677" />
          </div>
        </Card>

        <Card className="p-4 bg-amber-50 border-amber-200" data-id="element-3678">
          <div className="flex items-center justify-between" data-id="element-3679">
            <div data-id="element-3680">
              <p className="text-xs text-amber-700 mb-1" data-id="element-3681">In Transit</p>
              <p className="text-2xl font-bold text-amber-900" data-id="element-3682">1</p>
            </div>
            <Truck className="w-8 h-8 text-amber-600" data-id="element-3683" />
          </div>
        </Card>

        <Card className="p-4 bg-green-50 border-green-200" data-id="element-3684">
          <div className="flex items-center justify-between" data-id="element-3685">
            <div data-id="element-3686">
              <p className="text-xs text-green-700 mb-1" data-id="element-3687">Arrived</p>
              <p className="text-2xl font-bold text-green-900" data-id="element-3688">1</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" data-id="element-3689" />
          </div>
        </Card>

        <Card className="p-4 bg-slate-50 border-slate-200" data-id="element-3690">
          <div className="flex items-center justify-between" data-id="element-3691">
            <div data-id="element-3692">
              <p className="text-xs text-slate-700 mb-1" data-id="element-3693">Scheduled</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-3694">1</p>
            </div>
            <Clock className="w-8 h-8 text-slate-600" data-id="element-3695" />
          </div>
        </Card>
      </div>

      {/* Inbound List */}
      <div className="space-y-4" data-id="element-3696">
        {inboundOrders.map(order => <Card key={order.id} className="p-6" data-id="element-3697">
            <div className="flex items-start gap-6" data-id="element-3698">
              {/* Status Icon */}
              <div className="flex-shrink-0" data-id="element-3699">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center shadow-lg ${order.status === 'in_transit' ? 'bg-gradient-to-br from-amber-500 to-amber-600' : order.status === 'scheduled' ? 'bg-gradient-to-br from-slate-400 to-slate-500' : 'bg-gradient-to-br from-green-500 to-green-600'}`} data-id="element-3700">
                  {order.status === 'arrived' ? <CheckCircle className="w-8 h-8 text-white" data-id="element-3701" /> : order.status === 'in_transit' ? <Truck className="w-8 h-8 text-white" data-id="element-3702" /> : <Clock className="w-8 h-8 text-white" data-id="element-3703" />}
                </div>
              </div>

              {/* Order Info */}
              <div className="flex-1 min-w-0" data-id="element-3704">
                <div className="flex items-start justify-between mb-3" data-id="element-3705">
                  <div data-id="element-3706">
                    <div className="flex items-center gap-3 mb-2" data-id="element-3707">
                      <h3 className="text-xl font-bold text-slate-900" data-id="element-3708">
                        {order.poNumber}
                      </h3>
                      <Badge variant={getStatusColor(order.status)} data-id="element-3709">
                        {order.statusLabel}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-3710">
                      <span data-id="element-3711">ID: {order.id}</span>
                      <span className="text-slate-400" data-id="element-3712">•</span>
                      <span data-id="element-3713">From: {order.supplier}</span>
                      <span className="text-slate-400" data-id="element-3714">•</span>
                      <span data-id="element-3715">Tracking: {order.trackingNumber}</span>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-3716">
                    <p className="text-sm text-slate-600 mb-1" data-id="element-3717">Total Items</p>
                    <p className="text-2xl font-bold text-cyan-600" data-id="element-3718">
                      {order.totalItems}
                    </p>
                  </div>
                </div>

                {/* Products */}
                <div className="mb-4 p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-3719">
                  <p className="text-xs font-bold text-slate-700 mb-2" data-id="element-3720">
                    Products:
                  </p>
                  <div className="space-y-1" data-id="element-3721">
                    {order.products.map((product, i) => <div key={i} className="flex items-center justify-between text-sm" data-id="element-3722">
                        <span className="text-slate-900" data-id="element-3723">{product.name}</span>
                        <span className="font-medium text-slate-600" data-id="element-3724">
                          {product.quantity} {product.unit}
                        </span>
                      </div>)}
                  </div>
                </div>

                {/* Details */}
                <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-3725">
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3726">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3727">
                      Expected Arrival
                    </p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3728">
                      {order.expectedDate}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3729">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3730">Courier</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3731">
                      {order.courier}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3732">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3733">Notes</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-3734">
                      {order.notes}
                    </p>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-3735">
                  {order.status === 'arrived' && <>
                      <Button variant="primary" size="sm" icon={<CheckCircle className="w-4 h-4" data-id="element-3737" />} data-id="element-3736">
                        Process Receiving
                      </Button>
                      <Button variant="outline" size="sm" icon={<FileText className="w-4 h-4" data-id="element-3739" />} data-id="element-3738">
                        Print Label
                      </Button>
                    </>}
                  {order.status === 'in_transit' && <Button variant="outline" size="sm" icon={<Truck className="w-4 h-4" data-id="element-3741" />} data-id="element-3740">
                      Track Shipment
                    </Button>}
                  <Button variant="outline" size="sm" data-id="element-3742">
                    View Details
                  </Button>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}